module.exports = __webpack_public_path__ + "img/06.54559b0d.png";